import { AcornsIcon } from '@acorns/icons'
import styled from 'styled-components'

import { style } from 'theme'

const HeroHeader = styled.h2`
  font-size: 22px;
  line-height: 30px;
  margin: 30px auto 10px;
  text-align: center;
  font-weight: bold;
  max-width: 400px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 0px auto 10px;
  }
`

const HeroText = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 40px;
  text-align: center;
  max-width: 400px;
`

const AddressCard = styled.div`
  display: flex;
  justify-content: space-between;
  width: 400px;
  margin: 40px auto 80px;
  padding: 20px;
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);
  position: relative;
  border-radius: ${style(theme => theme.borderRadius.large)};
  cursor: pointer;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

const AddressCardContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm - 1)}px) {
    margin-bottom: 0;
  }
`

const AddressHeader = styled.h2`
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  margin: 0 0 5px 0;
  color: ${style(theme => theme.colors.slate)};
`

const AddressBody = styled.div`
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${style(theme => theme.colors.slate)};
`

const EditIcon = styled(AcornsIcon)`
  align-self: center;
`

export {
  HeroHeader,
  HeroText,
  AddressCard,
  AddressCardContainer,
  EditIcon,
  AddressHeader,
  AddressBody,
}
